module.exports = __webpack_public_path__ + "img/hypervisor-1.698eb1a6.webp";